import { fixAdd } from '../../../helpers/math'

export const getFiveItems = (arr, attr) => {
  const MAX_LENGTH = 5
  arr.sort((a, b) => b[attr] - a[attr])

  let sum = 0
  let limit = MAX_LENGTH

  for (let index = 0; index < arr.length; index++) {
    const item = arr[index]
    sum = fixAdd(sum, item[attr])

    if (sum > 1) {
      limit = index
      break
    }
  }

  return arr.slice(0, Math.min(limit, MAX_LENGTH))
}
